import {Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, ViewChild} from '@angular/core';
import {ConnecttocrudService} from '../connecttocrud.service';
import {ConfService} from '../conf.service';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {KongService} from '../kong.service';
import {GatewayComponent} from '../gateway/gateway.component';
import {BasicAuthComponent} from '../gateway/Authentication/BasicAuth/BasicAuth.component';
import {MasterPluginComponent} from '../master-plugin/master-plugin.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {AppComponent} from '../app.component';
import {AddGatewayResourceComponent, LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {ApiRegistrarSettingsComponent} from '../settings/api-registrar-settings/api-registrar-settings.component';
import {ApigatewayListenerService} from '../apigateway-listener.service';

declare let $;

export interface PluginData {
    data: any;
}

export interface ApplyConfigurationsToRouteData {
    data: any;
}

@Component({
    selector: 'app-apimanagement',
    templateUrl: './apimanagement.component.html',
    styleUrls: ['./apimanagement.component.css'],
    providers: [GatewayComponent, BasicAuthComponent]
})
export class ApimanagementComponent implements OnInit, OnChanges {
    temp2: string[];
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    partnerShortCode: any;
    loggedInEnvironment: any;
    panelOpenState = false;
    routeName: string;
    isDisabled = true;
    @Input() entity = '';
    @Input() version = '';
    @Input() methods = [];
    @Input() flag: any;
    language: string;
    partnerKey: string;
    items: any;
   selectedItems = [];
    intermediateConfigurationsForPluginKey: any;
    intermediateConfigurationsForRoutePluginKey: any;

    routePluginKeyDisplayName = []
    servicePluginKeyDisplayName = [];

    showServiceDetails = true;
    showServicePlugins = false;
    showRoutesForService = false;
    showRouteDetails = false;
    showRoutePlugins = false;
    showEditPlugins = false;
    showEditPluginsForRoute = false;
    pluginConfigurationIndex: any;
    pluginEnabled = true;
    routePluginEnabled = true;
    intermediateConfigurationsForPlugin = {};
    intermediateConfigurationsForRoutePlugin = {};
    keys: string[];
    typeOfKey: string [];
    typeOfKeys: string[];
    selectable = true;
    removable = true;
    addOnBlur = true;
    indexOfRoute: any;
    @Output() selectChange = new EventEmitter<any>();
    @Output() methodTypeListener = new EventEmitter<any>();
    @Output() APIGatewayListener = new EventEmitter<any>();
    @Output() APIGatewayRoutePathListener = new EventEmitter<any>();
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    categories = [
        {
            'name': 'Configuration',
            'function': 'showService()',
            'icon': 'fa-cog'
        },
        {
            'name': 'API Settings',
            'function': 'showPlugins()',
            'icon': 'fa-cogs'
        },
        {
            'name': 'Routes',
            'function': 'showRoutesForTheService()',
            'icon': 'fa-map-signs'
        }
    ];

    pluginData: any;
    pluginsConfiguredForService: any;
    pluginsConfiguredForRoute: any;
    routePlugins: any;


    color = 'green';
    checked = false;
    disabled = false;

    basicAuth: any;
    basicAuthId: any;
    basicAuthEnabled: any;

    keyAuth: any;
    keyAuthId: any;
    keyAuthEnabled: any;

    jwt: any;
    jwtId: any;
    jwtEnabled: any;

    botDetection: any;
    botDetectionId: any;
    botDetectionEnabled: any;

    cors: any;
    corsId: any;
    corsEnabled: any;
    acl: any;
    aclId: any;
    aclEnabled: boolean;

    rateLimiting: any;
    rateLimitingId: any;
    rateLimitingEnabled: boolean;


    requestTermination: any;
    requestTerminationId: any;
    requestTerminationEnabled: any;

    requestSizeLimiting: any;
    requestSizeLimitingId: any;
    requestSizeLimitingEnabled: boolean;

    ipRestriction: any;
    ipRestrictionId: any;
    ipRestrictionEnabled: boolean;

    gatewayService: any;
    gatewayRoute: any;
    orig_gateway_route: any;
    serviceId: any;
    gatewayRoutes: any;
    gatewayPlugins: any;
    routes: any;
    pathRouteId: any;
    hostRouteId: any;

    pathRouteRateLimitingPluginId: any;
    hostRouteRateLimitingPluginId: any;
    pathRoutePlugins: any;
    hostRoutePlugins: any;

    pathRouteBasicAuthPluginId: any;
    hostRouteBasicAuthPluginId: any;

    pathRouteKeyAuthPluginId: any;
    hostRouteKeyAuthPluginId: any;
    pathRouteKeyAuthPlugin: any;
    hostRouteKeyAuthPlugin: any;

    attributes: any;
    operations: any;
    gatewaySettings: any;
    error = false;
    errorMessage: string;
    commons = [];
    user: any;
    plugin: any;
    pluginConfig = {};
    date: any;
    type: any;
    serviceTags = [];
    tls_verify = true;
    tls_verify_depth = '';
    ca_certificates = [];
    loading = true;
    genericFlag: boolean;
    constructor(private _service: ConnecttocrudService, private confPost: ConfService, private kong: KongService,
                private location: Location, public dialog: MatDialog,
                private route: ActivatedRoute, public platform: LeftpanelComponent,
                public snackBar: MatSnackBar, private router: Router, private Urlroute: ActivatedRoute,
                private basicAuthInstance: BasicAuthComponent, private apiGatewayListenerInstance: ApigatewayListenerService,
                private masterPluginDataInstance: MasterPluginComponent, private appComp: AppComponent
    ) {
        setTimeout(() => {
        this.methodTypeListener.subscribe(async object => {
            this.methods = object.methodType;
            this.gatewayService.name = this.partner + '-' + this.account + '-' + object.entityName + '-' + object.version;
            this.gatewayService.path = '/' + object.version + '/data/' + this.partner + '/' + this.account + '/' + object.entityName;
            // this.gatewayRoute.data[0].name = this.partner + '-' + this.account + '-' + object.entityName + '-' + object.version + '-path';
            // this.gatewayRoute.data[0].methods = this.methods;

            this.gatewayRoute.data = [];
            for (const method of this.methods) {
                const routePayload = {
                    name: this.partner + '-' + this.account + '-' + object.entityName + '-' + object.version + '-' + method,
                    protocols: ['https', 'http'],
                    hosts: [await this.platform.getDefaultGatewayURL()],
                    paths: [],
                    methods: [method]
                };

                if (method === 'OPTIONS') {
                    if (this.methods.includes('POST') === false) {
                        if (routePayload.methods.includes('POST') === false) {
                            routePayload.methods.push('POST');
                        }
                    }
                }

                this.gatewayRoute.data.push(routePayload);
            }
        });
        }, 300);
        this.APIGatewayListener.subscribe(object => {
            if (object && object.selectedAPIGateway) {
                const accessURLS = object.selectedAPIGateway.url;
                // this.gatewayRoute.data[0].hosts = [];
                // if (accessURLS && accessURLS.length > 0) {
                //     for (const url of accessURLS) {
                //         if (url && url !== '') {
                //             this.gatewayRoute.data[0].hosts.push(url);
                //         }
                //     }
                // }
            }
        });

        this.route.queryParams
            .subscribe(async params => {
                const that = this;
                // setTimeout(function() {
                    if (this.router.url.includes('apimanagement')) {
                        if (params && params.partner && params.account) {
                            this.genericFlag = false;
                            this.partner = params.partner;
                            this.account = params.account;
                            this.entity = params.entity;
                            this.version = params.version;
                            this.type = params.type;
                            if (params.language != null) {
                                this.language = params.language;
                            } else {
                                this.language = 'en';
                            }
                            this.partnerKey = localStorage.getItem('partnerKey');
                            this.items = null;
                            // this.getGatewayItems();
                            Promise.resolve(this.getGatewayService()).then(resp => {});
                            Promise.resolve(this.getGatewayRoutes()).then(resp => {});
                        }
                    } else {
                        this.genericFlag = true;
                        this.gatewayService = {
                            name: this.partner + '-' + this.account + '-' + this.entity + '-' + this.version,
                            protocol: 'https',
                            host: 'services.apiplatform.io',
                            port: 443,
                            retries: 5,
                            path: '',
                            connect_timeout: 60000,
                            read_timeout: 60000,
                            write_timeout: 60000,
                            tags: []
                        };
                        this.gatewayRoute = {
                            data: [
                                {
                                    name: this.partner + '-' + this.account + '-' + this.entity + '-' + this.version + '-path',
                                    protocols: ['https', 'http'],
                                    hosts: [await this.platform.getDefaultGatewayURL()],
                                    paths: [],
                                    methods: this.methods
                                }
                            ]
                        };
                        // this.gatewayRoute = {
                        //     data: []
                        // };
                    }
                // }, 500);
            });
    }

    getGatewayRoutes() {
        return new Promise((resolve, reject) => {
            this.kong.getRoutesForAServiceFromApiGateway(this.partner + '-' + this.account + '-' + this.entity + '-' + this.version).subscribe(service => {
                this.gatewayRoute = service;
                this.orig_gateway_route = service;
                let isRoutesOldDesign = false;
                for (const route of this.gatewayRoute['data']) {
                    if (route['methods'] === null || route['methods'] === undefined || (route['methods'] && (route['methods'].length === 0 || (route['name'] !== this.partner + '-' + this.account + '-' + this.entity + '-' + this.version + '-' + 'OPTIONS' && route['methods'].length > 1)))) {
                        isRoutesOldDesign = true;
                        break;
                    }
                }
                if (isRoutesOldDesign === true) {
                    this.kong.getPluginsForRouteInApiGateway(this.gatewayRoute['data'][0]['name']).subscribe(async plugins => {
                        this.pluginsConfiguredForRoute = plugins['data'];
                        await this.kong.updateExistingRoutes(this.partner, this.account, this.entity, this.version, this.gatewayRoute['data'], this.pluginsConfiguredForRoute, true, '', '');
                        await this.getGatewayRoutes();
                    }, error => {
                        this.platform.handleErrorGracefully(error, 'Error while fetching plugins for the route from API Gateway. Please try after sometime.');
                        this.router.navigateByUrl('/controlplane');
                    });
                } else {
                    resolve('success');
                }
                }, error => {
                // this.platform.handleErrorGracefully(error, 'Error while fetching routes for a service from API Gateway. Please try after sometime.');
                reject('failed');
            });
        });
    }

    getGatewayService() {
        return new Promise((resolve, reject) => {
            this.kong.getServicesFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + this.entity + '-' + this.version).subscribe(service => {
                this.gatewayService = service;
                if (this.gatewayService['ca_certificates'] === null || this.gatewayService['ca_certificates'] === undefined) {
                    this.gatewayService['ca_certificates'] = [];
                }
                if (this.gatewayService['tags'] === null || this.gatewayService['tags'] === undefined) {
                    this.gatewayService['tags'] = [];
                }
                if(this.gatewayService['client_certificate'] === null || this.gatewayService['client_certificate'] === undefined) {
                    this.gatewayService['client_certificate'] = '';
                }
                this.kong.getPluginsForServiceInApiGateway(this.gatewayService['name']).subscribe(plugins => {
                    this.pluginsConfiguredForService = plugins['data'];
                });
                resolve('success');
            }, error => {
                if (error.status === 404) {
                    if (this.type === 'entity') {
                        this.confPost.getEntity(this.partner, this.account, this.entity, this.version).subscribe(response => {
                            if (response) {
                                const dialogRef = this.dialog.open(AddGatewayResourceComponent, {
                                    width: 'auto',
                                    height: 'auto',
                                    data: {
                                        entity: this.entity,
                                        version: this.version,
                                        partner: this.partner,
                                        account: this.account,
                                        methods: response['methods'],
                                        isExecutor: false,
                                        parentURL: this.router.url
                                    }
                                });
                            } else {
                                this.platform.openSnackBar('Error while fetching the entity. Please try again after sometime.', 'Error', {
                                    duration: 15000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                this.router.navigateByUrl('/controlplane');
                            }
                        }, error1 => {
                            this.platform.handleErrorGracefully(error1, 'Error while fetching the entity. Please try again after sometime.');
                            this.router.navigateByUrl('/controlplane');
                        });
                    }

                    if (this.type === 'executor') {
                        this.confPost.getApiExecutorByPartnerAccountEntityVersion(this.partner, this.account, this.entity, this.version).subscribe(response => {
                            if (response) {
                                const dialogRef = this.dialog.open(AddGatewayResourceComponent, {
                                    width: 'auto',
                                    height: 'auto',
                                    data: {
                                        entity: this.entity,
                                        version: this.version,
                                        partner: this.partner,
                                        account: this.account,
                                        methods: [response['executor_method_type']],
                                        isExecutor: true,
                                        parentURL: this.router.url
                                    }
                                });
                            } else {
                                this.platform.openSnackBar('Error while fetching the executor. Please try again after sometime.', 'Error', {
                                    duration: 15000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                this.router.navigateByUrl('/controlplane');
                            }
                        }, error1 => {
                            this.platform.handleErrorGracefully(error1, 'Error while fetching the executor. Please try again after sometime.');
                            this.router.navigateByUrl('/controlplane');
                        });
                    }
                } else {
                    this.router.navigateByUrl('/controlplane');
                    this.platform.handleErrorGracefully(error, 'Error while fetching services from API Gateway. Please try after sometime.');
                }
            });
        });
    }

    stringify(parameter) {
        return JSON.stringify(parameter);
    }

    async ngOnChanges() {
        this.gatewayService = {
            name: this.partner + '-' + this.account + '-' + this.entity + '-' + this.version,
            protocol: 'https',
            host: 'services.apiplatform.io',
            port: 443,
            retries: 5,
            path: '/' + this.version + '/data/' + this.partner + '/' + this.account + '/' + this.entity,
            connect_timeout: 60000,
            read_timeout: 60000,
            write_timeout: 60000,
            tags: []
        };
        // const methodTypes = [];
        // this.methods.forEach(method => {
        //     methodTypes.push(method.id);
        // });

        // this.gatewayRoute = {
        //     data: [
        //         {
        //             name: this.partner + '-' + this.account + '-' + this.entity + '-' + this.version + '-path',
        //             protocols: ['https', 'http'],
        //             hosts: [await this.platform.getDefaultGatewayURL()],
        //             paths: [],
        //             methods: this.methods
        //         }
        //     ]
        // };


        // this.gatewayRoute.data[0].name = this.partner + '-' + this.account + '-' + this.entity + '-' + this.version + '-path';
        // this.gatewayRoute.data[0].methods = this.methods;

        if (this.gatewayRoute !== null && this.gatewayRoute !== undefined) {
            this.gatewayRoute.data = [];
            for (const method of this.methods) {
                const routePayload = {
                    name: this.partner + '-' + this.account + '-' + this.entity + '-' + this.version + '-' + method,
                    protocols: ['https', 'http'],
                    hosts: [await this.platform.getDefaultGatewayURL()],
                    paths: [],
                    methods: [method]
                };
                this.gatewayRoute.data.push(routePayload);
            }
        }


    }


    async ngOnInit() {
        if (this.flag === undefined) {
            this.flag = false;
        }
        const temp = this.partner.split('-');
        this.partnerShortCode = temp[temp.length - 1];
        if (temp.length > 1) {
            this.loggedInEnvironment = temp[0];
        } else {
            this.loggedInEnvironment = 'prod';
        }
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
            this.loading = false;
        } else {
            this.loading = false;
        }
        this.appComp.currentPageTitle = 'API Gateway Settings';
        $('ul li').click(function () {
            $(this).addClass('selected').siblings().removeClass('selected');
        });
    }

    customTrackBy(index: number, obj: any): any {
        return index;
    }

    categoryClick(item) {
        switch (item.function) {
            case 'showService()' :
                this.showService();
                break;
            case 'showPlugins()' :
                this.showPlugins();
                break;
            case 'showRoutesForTheService()' :
                this.showRoutesForTheService();
                break;
        }
    }

    convertTimestamp(timestamp): string {

        const unixtimestamp = timestamp;
        const months_arr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        this.date = new Date(unixtimestamp * 1000);
        const year = this.date.getFullYear();
        const month = months_arr[this.date.getMonth()];
        const day = this.date.getDate();
        const hours = this.date.getHours();
        const minutes = '0' + this.date.getMinutes();
        const seconds = '0' + this.date.getSeconds();
        return month + '-' + day + '-' + year + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
        // this.lastUpdatedON = month + '-' + day + '-' + year + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
    }

    showService() {
        this.showServiceDetails = true;
        this.showServicePlugins = false;
        this.showEditPlugins = false;
        this.showRouteDetails = false;
        this.showRoutePlugins = false;
        this.showEditPluginsForRoute = false;
    }

    showPlugins() {
        this.showServiceDetails = false;
        this.showServicePlugins = true;
        this.showEditPlugins = false;
        this.showRouteDetails = false;
        this.showRoutePlugins = false;
        this.showEditPluginsForRoute = false;


    }

    showRoutesForTheService() {
        this.showServiceDetails = false;
        this.showServicePlugins = false;
        this.showEditPlugins = false;
        this.showRouteDetails = true;
        this.showRoutePlugins = false;
        this.showEditPluginsForRoute = false;


    }

    async showPluginsForRoute(indexOfRoute) {
        this.showServiceDetails = false;
        this.showServicePlugins = false;
        this.showEditPlugins = false;
        this.showRouteDetails = false;
        this.showRoutePlugins = true;
        this.showEditPluginsForRoute = false;
        this.indexOfRoute = indexOfRoute;
        this.routeName = this.gatewayRoute['data'][indexOfRoute]['name'];
        this.kong.getPluginsForRouteInApiGateway(this.routeName).subscribe(plugins => {
            this.pluginsConfiguredForRoute = plugins['data'];
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while fetching plugins for the route from API Gateway. Please try after sometime.');
        });
    }
    emitSel(val){
        this.selectChange.emit(val);
    }
    editPluginConfigurations(index) {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_servicesplugins_edit_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.apiGatewayListenerInstance.apiGatewayListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        this.showServiceDetails = false;
        this.showServicePlugins = false;
        this.showEditPlugins = true;
        this.showRouteDetails = false;
        this.showRoutePlugins = false;
        this.showEditPluginsForRoute = false;


        this.pluginConfigurationIndex = index;
        this.pluginEnabled = this.pluginsConfiguredForService[index]['enabled'];
        this.intermediateConfigurationsForPlugin = this.pluginsConfiguredForService[index]['config'];
        this.intermediateConfigurationsForPluginKey = [];
        this.servicePluginKeyDisplayName = [];
        const that = this;
        for (const keys in this.intermediateConfigurationsForPlugin) {
            that.intermediateConfigurationsForPluginKey.push(keys);
        }
        // if (this.pluginsConfiguredForService[index]['name'] === 'ip-restriction') {
        //     if (this.intermediateConfigurationsForPlugin.hasOwnProperty('whitelist')) {
        //         if (this.intermediateConfigurationsForPlugin['whitelist'] === null) {
        //             this.intermediateConfigurationsForPlugin['allow'] = [];
        //             delete this.intermediateConfigurationsForPlugin['whitelist'];
        //         } else {
        //             this.intermediateConfigurationsForPlugin['allow'] = this.intermediateConfigurationsForPlugin['whitelist'];
        //             delete this.intermediateConfigurationsForPlugin['whitelist'];
        //         }
        //     }
        //     if (this.intermediateConfigurationsForPlugin.hasOwnProperty('blacklist')) {
        //         if (this.intermediateConfigurationsForPlugin['blacklist'] === null) {
        //             this.intermediateConfigurationsForPlugin['deny'] = [];
        //             delete this.intermediateConfigurationsForPlugin['blacklist'];
        //         } else {
        //             this.intermediateConfigurationsForPlugin['deny'] = this.intermediateConfigurationsForPlugin['blacklist'];
        //             delete this.intermediateConfigurationsForPlugin['blacklist'];
        //         }
        //     }
        //     if (this.intermediateConfigurationsForPluginKey) {
        //         for (let i = 0; i < this.intermediateConfigurationsForPluginKey.length; i++) {
        //             if (this.intermediateConfigurationsForPluginKey[i] === 'whitelist') {
        //                 this.intermediateConfigurationsForPluginKey[i] = 'allow';
        //             } else if (this.intermediateConfigurationsForPluginKey[i] === 'blacklist') {
        //                 this.intermediateConfigurationsForPluginKey[i] = 'deny';
        //             }
        //         }
        //     }
        // }
        const length = Object.keys(this.intermediateConfigurationsForPlugin).length;
        this.keys = Object.keys(this.intermediateConfigurationsForPlugin);
        const temp = Object.keys(this.intermediateConfigurationsForPlugin);
        for (let i = 0; i < this.masterPluginDataInstance.masterPluginData[0]['category'].length; i++) {
            for (let j = 0; j < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'].length; j++) {
                if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['name'] === this.pluginsConfiguredForService[index]['name']) {


                    // for (let k = 0; k < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'].length; k++) {
                    for (let k = 0; k < this.keys.length; k++) {
                        // if (this.pluginsConfiguredForService[index]['name'] === 'ip-restriction') {
                        //     if (this.keys) {
                        //         for (let l = 0; l < this.keys.length; l++) {
                        //             if (this.keys[l] === 'whitelist') {
                        //                 this.keys[l] = 'allow';
                        //             } else if (this.keys[l] === 'blacklist') {
                        //                 this.keys[l] = 'deny';
                        //             }
                        //         }
                        //     }
                        // }



                        // for (let x = 0; x < this.keys.length; x++) {
                        for (let x = 0; x < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'].length; x++) {
                            if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x] && this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x].hasOwnProperty('parameter')) {
                                if (this.keys[k] === this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x]['parameter']) {
                                    if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x]['type'] === 'array_string') {
                                        if (this.intermediateConfigurationsForPlugin[this.keys[k]] === null || this.intermediateConfigurationsForPlugin[this.keys[k]] === undefined || this.intermediateConfigurationsForPlugin[this.keys[k]] === '') {
                                            this.intermediateConfigurationsForPlugin[this.keys[k]] = [];
                                        }
                                    }
                                    temp[k] = this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x]['type'];
                                }

                                if (this.intermediateConfigurationsForPluginKey[k] === this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x]['parameter']) {
                                    this.servicePluginKeyDisplayName[k] = this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x]['displayName'];
                                }
                            }
                        }
                    }
                }
            }
        }
        this.typeOfKeys = temp;
    }

    editPluginConfigurationsForRoute(index) {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_routesplugins_edit_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.apiGatewayListenerInstance.apiGatewayListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        this.showServiceDetails = false;
        this.showServicePlugins = false;
        this.showEditPlugins = false;
        // this.showRoutesForService = false;
        this.showRouteDetails = false;
        this.showRoutePlugins = false;
        this.showEditPluginsForRoute = true;

        this.pluginConfigurationIndex = index;
        this.routePluginEnabled = this.pluginsConfiguredForRoute[index]['enabled'];
        this.intermediateConfigurationsForRoutePlugin = this.pluginsConfiguredForRoute[index]['config'];
        this.intermediateConfigurationsForRoutePluginKey = [];
        this.routePluginKeyDisplayName = [];
        const that = this;
        for (const keys in this.intermediateConfigurationsForRoutePlugin) {
            that.intermediateConfigurationsForRoutePluginKey.push(keys);
        }
        // if (this.pluginsConfiguredForRoute[index]['name'] === 'ip-restriction') {
        //     if (this.intermediateConfigurationsForRoutePlugin.hasOwnProperty('whitelist')) {
        //         if (this.intermediateConfigurationsForRoutePlugin['whitelist'] === null) {
        //             this.intermediateConfigurationsForRoutePlugin['allow'] = [];
        //             delete this.intermediateConfigurationsForRoutePlugin['whitelist'];
        //         } else {
        //             this.intermediateConfigurationsForRoutePlugin['allow'] = this.intermediateConfigurationsForRoutePlugin['whitelist'];
        //             delete this.intermediateConfigurationsForRoutePlugin['whitelist'];
        //         }
        //     }
        //     if (this.intermediateConfigurationsForRoutePlugin.hasOwnProperty('blacklist')) {
        //         if (this.intermediateConfigurationsForRoutePlugin['blacklist'] === null) {
        //             this.intermediateConfigurationsForRoutePlugin['deny'] = [];
        //             delete this.intermediateConfigurationsForRoutePlugin['blacklist'];
        //         } else {
        //             this.intermediateConfigurationsForRoutePlugin['deny'] = this.intermediateConfigurationsForRoutePlugin['blacklist'];
        //             delete this.intermediateConfigurationsForRoutePlugin['blacklist'];
        //         }
        //     }
        //     if (this.intermediateConfigurationsForRoutePluginKey) {
        //         for (let i = 0; i < this.intermediateConfigurationsForRoutePluginKey.length; i++) {
        //             if (this.intermediateConfigurationsForRoutePluginKey[i] === 'whitelist') {
        //                 this.intermediateConfigurationsForRoutePluginKey[i] = 'allow';
        //             } else if (this.intermediateConfigurationsForRoutePluginKey[i] === 'blacklist') {
        //                 this.intermediateConfigurationsForRoutePluginKey[i] = 'deny';
        //             }
        //         }
        //     }
        // }
        const length = Object.keys(this.intermediateConfigurationsForRoutePlugin).length;
        this.keys = Object.keys(this.intermediateConfigurationsForRoutePlugin);
        const temp = Object.keys(this.intermediateConfigurationsForRoutePlugin);
        for (let i = 0; i < this.masterPluginDataInstance.masterPluginData[0]['category'].length; i++) {
            for (let j = 0; j < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'].length; j++) {
                if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['name'] === this.pluginsConfiguredForRoute[index]['name']) {
                    for (let k = 0; k < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'].length; k++) {
                        // if (this.pluginsConfiguredForRoute[index]['name'] === 'ip-restriction') {
                        //     if (this.keys) {
                        //         for (let l = 0; l < this.keys.length; l++) {
                        //             if (this.keys[l] === 'whitelist') {
                        //                 this.keys[l] = 'allow';
                        //             } else if (this.keys[l] === 'blacklist') {
                        //                 this.keys[l] = 'deny';
                        //             }
                        //         }
                        //     }
                        // }
                        for (let x = 0; x < this.keys.length; x++) {
                            if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x] && this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x].hasOwnProperty('parameter')) {
                                if (this.keys[k] === this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x]['parameter']) {
                                    if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x]['type'] === 'array_string') {
                                        if (this.intermediateConfigurationsForRoutePlugin[this.keys[k]] === null || this.intermediateConfigurationsForRoutePlugin[this.keys[k]] === undefined || this.intermediateConfigurationsForRoutePlugin[this.keys[k]] === '') {
                                            this.intermediateConfigurationsForRoutePlugin[this.keys[k]] = [];
                                        }
                                    }
                                    temp[k] = this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x]['type'];
                                }

                                if (this.intermediateConfigurationsForRoutePluginKey[k] === this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x]['parameter']) {
                                    this.routePluginKeyDisplayName[k] = this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][x]['displayName'];
                                }
                            }
                        }
                    }
                }
            }
        }
        this.typeOfKeys = temp;
    }

    removePlugin(index) {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_servicesplugins_delete_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.apiGatewayListenerInstance.apiGatewayListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        const pluginIdToRemove = this.pluginsConfiguredForService[index];
        this.kong.deletePluginFromApiGateway(pluginIdToRemove['id']).subscribe(response => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_servicesplugins_delete_success', 'INFO', 200, 'OK', '', {serviceName: this.gatewayService['name'], id: pluginIdToRemove['id'], payload: pluginIdToRemove}, response, this.router.url)).then(resp => {
                const payloadToSend = {
                    actions: resp
                };
                this.apiGatewayListenerInstance.apiGatewayListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            this.platform.openSnackBar(pluginIdToRemove['name'] + ' successfully deleted for this service', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            location.reload();
        }, error => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'apigateway_servicesplugins_delete_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {serviceName: this.gatewayService['name'], id: pluginIdToRemove['id'], payload: pluginIdToRemove}, error, this.router.url)).then(resp => {
                const payloadToSend = {
                    actions: resp
                };
                this.apiGatewayListenerInstance.apiGatewayListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            this.platform.handleErrorGracefully(error, 'Error while deleting  ' + pluginIdToRemove['name'] + ' for this service. Please try after sometime.');
            // this.platform.openSnackBar('Error while deleting  ' + pluginIdToRemove['name'] + ' for this service', 'Error', {
            //     duration: 5000,
            //     verticalPosition: 'top',
            //     horizontalPosition: 'center'
            // });
        });
    }

    removePluginForRoute(index) {
        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_routesplugins_delete_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.apiGatewayListenerInstance.apiGatewayListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });
        const pluginIdToRemove = this.pluginsConfiguredForRoute[index];
        this.kong.deletePluginFromApiGateway(pluginIdToRemove['id']).subscribe(response => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_routesplugins_delete_success', 'INFO', 200, 'OK', '', {serviceName: this.gatewayService['name'], id: pluginIdToRemove['id'], payload: pluginIdToRemove}, response, this.router.url)).then(resp => {
                const payloadToSend = {
                    actions: resp
                };
                this.apiGatewayListenerInstance.apiGatewayListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            this.platform.openSnackBar(pluginIdToRemove['name'] + ' successfully deleted for this route', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            setTimeout(() => {
                location.reload();
            }, 1000);
        }, error => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'apigateway_routesplugins_delete_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {serviceName: this.gatewayService['name'], id: pluginIdToRemove['id'], payload: pluginIdToRemove}, error, this.router.url)).then(resp => {
                const payloadToSend = {
                    actions: resp
                };
                this.apiGatewayListenerInstance.apiGatewayListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            this.platform.handleErrorGracefully(error, 'Error while deleting  ' + pluginIdToRemove['name'] + ' for this route. Please try after sometime.');
            // this.platform.openSnackBar('Error while deleting ' + pluginIdToRemove['name'] + ' for this route', 'Error', {
            //     duration: 5000,
            //     verticalPosition: 'top',
            //     horizontalPosition: 'center'
            // });
        });
    }

    add(event, data): void {
        const input = event.input;
        const value = event.value;

        // Add our fruit
        if ((value || '').trim()) {
            data.push(value.trim());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    addPath(event, data, index) {
        const input = event.input;
        const value = event.value;

        // Add our fruit
        if ((value || '').trim()) {
            data.push(value.trim());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }

        this.APIGatewayRoutePathListener.emit({routePathData: data, routeIndex: index});
    }

    remove(val, data): void {
        const index = data.indexOf(val);
        if (index >= 0) {
            if (this.pluginsConfiguredForRoute && this.pluginsConfiguredForRoute[this.pluginConfigurationIndex]['name'] === 'acl') {
                if (data.length === 1) {
                    if (confirm('Removing the allowable group will make the API method public. Do you still want to continue?')) {
                        data.splice(index, 1);
                    }
                } else {
                    data.splice(index, 1);
                }
            } else {
                data.splice(index, 1);
            }
        }
    }

    removePath(val, data, routeIndex) {
        const index = data.indexOf(val);

        if (index >= 0) {
            data.splice(index, 1);
        }
        this.APIGatewayRoutePathListener.emit({routePathData: data, routeIndex: routeIndex});
    }

    openDialog1(): void {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_services_addgatewaysettings_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.apiGatewayListenerInstance.apiGatewayListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        const pluginData = {};
        const dialogRef = this.dialog.open(PopUpComponent, {
            width: '99%',
            height: '80%',
            data: pluginData
        });
        dialogRef.afterClosed().subscribe(data => {
            this.intermediateConfigurationsForPlugin = {};
            if (data && data !== undefined) {
                for (let i = 0; i < data['config'].length; i++) {
                    this.intermediateConfigurationsForPlugin[data['config'][i]['parameter']] = data['config'][i]['value'];
                }
                this.plugin = {
                    'name': data['name'],
                    'enabled': true,
                    'config': this.intermediateConfigurationsForPlugin
                };
                for (let i = 0; i < this.masterPluginDataInstance.masterPluginData[0]['category'].length; i++) {
                    for (let j = 0; j < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'].length; j++) {
                        if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['name'] === this.plugin.name) {
                            for (let k = 0; k < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'].length; k++) {
                                if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][k]['type'] === 'array_string') {
                                    const temp = this.plugin.config[this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][k]['parameter']];
                                    if (temp !== null) {
                                        this.temp2 = temp.split(',');
                                        this.plugin.config[this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][k]['parameter']] = this.temp2;
                                    }

                                }
                            }
                        }
                    }
                }
                if ((this.pluginsConfiguredForService.filter(element => element.name === this.plugin.name)).length === 0) {
                    this.createPluginForService(this.plugin);
                } else {
                    this.platform.openSnackBar(this.plugin.name + ' already configured for this service' , 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }
        });

    }

    openDialog2(indexOfRoute): void {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_routes_addgatewaysettings_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.apiGatewayListenerInstance.apiGatewayListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        const pluginData = {};
        const dialogRef = this.dialog.open(PopUpComponent, {
            width: '99%',
            height: '80%',
            data: pluginData
        });
        dialogRef.afterClosed().subscribe(data => {
            if (data && data !== undefined) {
                this.intermediateConfigurationsForRoutePlugin = {};
                for (let i = 0; i < data['config'].length; i++) {
                    this.intermediateConfigurationsForRoutePlugin[data['config'][i]['parameter']] = data['config'][i]['value'];
                }
                this.plugin = {
                    'name': data['name'],
                    'enabled': true,
                    'config': this.intermediateConfigurationsForRoutePlugin
                };
                for (let i = 0; i < this.masterPluginDataInstance.masterPluginData[0]['category'].length; i++) {
                    for (let j = 0; j < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'].length; j++) {
                        if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['name'] === this.plugin.name) {
                            for (let k = 0; k < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'].length; k++) {
                                if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][k]['type'] === 'array_string') {
                                    const temp = this.plugin.config[this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][k]['parameter']];
                                    if (temp !== null) {
                                        this.temp2 = temp.split(',');
                                        this.plugin.config[this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][k]['parameter']] = this.temp2;
                                    }

                                }
                            }
                        }
                    }
                }
                this.routeName = this.gatewayRoute['data'][indexOfRoute]['name'];
                this.kong.getPluginsForRouteInApiGateway(this.routeName).subscribe(plugins => {
                    this.pluginsConfiguredForRoute = plugins['data'];
                    if ((this.pluginsConfiguredForRoute.filter(element => element.name === this.plugin.name)).length === 0) {
                        this.createPluginForRoute(indexOfRoute);
                    } else {
                        this.platform.openSnackBar(this.plugin.name + ' successfully already exists for this route', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while fetching plugins for the route from API Gateway. Please try after sometime.');
                });
            }
        });
    }

    getPluginsForRoute(route) {
        return new Promise((resolve, reject) => {
            this.kong.getPluginsForRouteInApiGateway(route['name']).subscribe(plugins => {
                resolve(plugins);
            }, error => {
                reject(error);
            });
        });
    }

    patchPluginInAPIGateway(route, id, plugin) {
        return new Promise((resolve, reject) => {
            this.kong.patchPluginInApiGateway(id, plugin).subscribe(response => {
                this.platform.openSnackBar(this.plugin.name + ' successfully updated for the route : ' + route['name'], 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                resolve('success');
            }, error => {
                this.platform.openSnackBar('Error while updating' + this.plugin.name + ' for the route : ' + route['name'] + '. Please try again after sometime', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                resolve('failed');
            });
        });
    }

    pluginEditConfiguration() {
        for (let i = 0; i < this.keys.length; i++) {
            if (this.keys[i] === 'second' || this.keys[i] === 'minute' || this.keys[i] === 'hour' || this.keys[i] === 'day' || this.keys[i] === 'month' || this.keys[i] === 'year') {
                if (this.intermediateConfigurationsForPlugin[this.keys[i]] !== null) {
                    this.intermediateConfigurationsForPlugin[this.keys[i]] = parseInt(this.intermediateConfigurationsForPlugin[this.keys[i]], 10);
                }
            }
        }
        const id = this.pluginsConfiguredForService[this.pluginConfigurationIndex]['id'];
        this.plugin = {
            'name': this.pluginsConfiguredForService[this.pluginConfigurationIndex]['name'],
            'enabled': this.pluginEnabled,
            'config': this.intermediateConfigurationsForPlugin
        };
        for (let i = 0; i < this.masterPluginDataInstance.masterPluginData[0]['category'].length; i++) {
            for (let j = 0; j < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'].length; j++) {
                if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['name'] === this.plugin.name) {
                    for (let k = 0; k < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'].length; k++) {
                        if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][k]['type'] === 'array_string') {
                            const temp = this.plugin.config[this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][k]['parameter']];
                            if (typeof temp !== 'object') {
                                this.temp2 = temp.split(',');
                                this.plugin.config[this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][k]['parameter']] = this.temp2;
                            }
                        }

                    }
                }
            }
        }
        this.kong.patchPluginInApiGateway(id, this.plugin).subscribe(response => {

            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_servicesplugins_edit_success', 'INFO', 200, 'OK', '', {serviceName: this.gatewayService['name'], id: id, payload: this.plugin}, response, this.router.url)).then(resp => {
                const payloadToSend = {
                    actions: resp
                };
                this.apiGatewayListenerInstance.apiGatewayListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });

            // if (this.pluginsConfiguredForService[this.pluginConfigurationIndex]['name'] === 'rate-limiting' || this.pluginsConfiguredForService[this.pluginConfigurationIndex]['name'] === 'cors') {
                const data = {
                    plugin: this.plugin
                };
                const dialogRef = this.dialog.open(ApplyToRouteComponent, {
                    width: '40%',
                    height: '40%',
                    data: data
                });
                dialogRef.afterClosed().subscribe(async responseFromDialog => {
                    if (responseFromDialog === 'add') {
                        if (this.gatewayRoute) {
                            for (let j = 0; j < this.gatewayRoute['data'].length; j++) {
                                const route = this.gatewayRoute['data'][j];
                                let pluginFound = false;
                                if (route) {
                                    await this.getPluginsForRoute(route).then(async plugins => {
                                        const pluginsConfiguredForRoute = plugins['data'];
                                        for (let i = 0; i < pluginsConfiguredForRoute.length; i++) {
                                            if (pluginsConfiguredForRoute[i]['name'] === this.pluginsConfiguredForService[this.pluginConfigurationIndex]['name']) {
                                                pluginFound = true;
                                                await this.patchPluginInAPIGateway(route, pluginsConfiguredForRoute[i]['id'], this.plugin).then(response1 => {
                                                    if (j === this.gatewayRoute['data'].length - 1) {
                                                        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_services_applytoroute_success', 'INFO', 200, 'OK', '', {serviceName: this.gatewayService['name'], routeName: route['name'], payload: this.plugin}, response1, this.router.url)).then(resp => {
                                                            const payloadToSend = {
                                                                actions: resp
                                                            };
                                                            this.apiGatewayListenerInstance.apiGatewayListener.emit({
                                                                type: 'audit',
                                                                id: localStorage.getItem('IdOfSession'),
                                                                payload: payloadToSend
                                                            });
                                                        });
                                                        setTimeout(() => {
                                                            location.reload();
                                                        }, 1000);
                                                    }
                                                }, error => {
                                                    Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'apigateway_services_applytoroute_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {serviceName: this.gatewayService['name'], routeName: route['name'], payload: this.plugin}, error, this.router.url)).then(resp => {
                                                        const payloadToSend = {
                                                            actions: resp
                                                        };
                                                        this.apiGatewayListenerInstance.apiGatewayListener.emit({
                                                            type: 'audit',
                                                            id: localStorage.getItem('IdOfSession'),
                                                            payload: payloadToSend
                                                        });
                                                    });
                                                    this.platform.openSnackBar('Error while updating the route' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                                                        duration: 5000,
                                                        verticalPosition: 'top',
                                                        horizontalPosition: 'center'
                                                    });
                                                });
                                            } else {
                                                if (j === this.gatewayRoute['data'].length - 1) {
                                                    setTimeout(() => {
                                                        location.reload();
                                                    }, 1000);
                                                }
                                            }
                                        }
                                    }, error => {
                                        this.platform.handleErrorGracefully(error, 'Error while fetching plugins for the route from API Gateway. Please try after sometime.');
                                    });
                                }
                            }
                        }
                    } else {
                        location.reload();
                    }
                });
            // } else {
            //     this.platform.openSnackBar(this.plugin.name + ' successfully updated for this service', 'Success', {
            //         duration: 5000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            //     location.reload();
            // }
        }, error => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'apigateway_servicesplugins_edit_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {serviceName: this.gatewayService['name'], id: id, payload: this.plugin}, error, this.router.url)).then(resp => {
                const payloadToSend = {
                    actions: resp
                };
                this.apiGatewayListenerInstance.apiGatewayListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            this.platform.handleErrorGracefully(error, 'Error while updating the route. Please try after sometime.');
            // this.platform.openSnackBar('Error while updating route' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
            //     duration: 5000,
            //     verticalPosition: 'top',
            //     horizontalPosition: 'center'
            // });
        });
    }

    pluginEditConfigurationForRoute() {
        for (let i = 0; i < this.keys.length; i++) {
            if (this.keys[i] === 'second' || this.keys[i] === 'minute' || this.keys[i] === 'hour' || this.keys[i] === 'day' || this.keys[i] === 'month' || this.keys[i] === 'year') {
                if (this.intermediateConfigurationsForRoutePlugin[this.keys[i]] !== null) {
                    this.intermediateConfigurationsForRoutePlugin[this.keys[i]] = parseInt(this.intermediateConfigurationsForRoutePlugin[this.keys[i]], 10);
                }
            }
        }
        const id = this.pluginsConfiguredForRoute[this.pluginConfigurationIndex]['id'];
        this.plugin = {
            'name': this.pluginsConfiguredForRoute[this.pluginConfigurationIndex]['name'],
            'enabled': this.routePluginEnabled,
            'config': this.intermediateConfigurationsForRoutePlugin
        };
        for (let i = 0; i < this.masterPluginDataInstance.masterPluginData[0]['category'].length; i++) {
            for (let j = 0; j < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'].length; j++) {
                if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['name'] === this.plugin.name) {
                    for (let k = 0; k < this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'].length; k++) {
                        if (this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][k]['type'] === 'array_string') {
                            const temp = this.plugin.config[this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][k]['parameter']];
                            if (typeof temp !== 'object') {
                                this.temp2 = temp.split(',');
                                this.plugin.config[this.masterPluginDataInstance.masterPluginData[0]['category'][i]['pluginsInTheCategory'][j]['config'][k]['parameter']] = this.temp2;
                            }
                        }

                    }
                }
            }
        }
        this.kong.patchPluginInApiGateway(id, this.plugin).subscribe(response => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_routesplugins_edit_success', 'INFO', 200, 'OK', '', {serviceName: this.gatewayService['name'], routeName: this.pluginsConfiguredForRoute[this.pluginConfigurationIndex]['name'], id: id, payload: this.plugin}, response, this.router.url)).then(resp => {
                const payloadToSend = {
                    actions: resp
                };
                this.apiGatewayListenerInstance.apiGatewayListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            this.platform.openSnackBar(this.plugin.name + ' successfully updated for this route', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            location.reload();
        }, error => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'apigateway_routesplugins_edit_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {serviceName: this.gatewayService['name'], routeName: this.pluginsConfiguredForRoute[this.pluginConfigurationIndex]['name'], id: id, payload: this.plugin}, error, this.router.url)).then(resp => {
                const payloadToSend = {
                    actions: resp
                };
                this.apiGatewayListenerInstance.apiGatewayListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            this.platform.handleErrorGracefully(error, 'Error while updating the route. Please try after sometime.');
            // this.platform.openSnackBar('Error while updating route' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
            //     duration: 5000,
            //     verticalPosition: 'top',
            //     horizontalPosition: 'center'
            // });
        });
    }

    async createPluginsInAllRoutes(gatewayRoute) {
        for (let i = 0; i < gatewayRoute['data'].length; i++) {
            await this.createPluginsInRoutesAlso(gatewayRoute, i);
            if (i === gatewayRoute['data'].length - 1) {
                setTimeout(() => {
                    location.reload();
                }, 1000);
            }
        }
    }

    createPluginsInRoutesAlso(gatewayRoute, i) {
        return new Promise((resolve, reject) => {
            this.kong.createPluginForRouteInApiGateway(gatewayRoute['data'][i]['name'], this.plugin).toPromise().then(responseFromGateway => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_services_applytoroute_success', 'INFO', 200, 'OK', '', {serviceName: this.gatewayService['name'], routeName: gatewayRoute['data'][i]['name'], payload: this.plugin}, responseFromGateway, this.router.url)).then(resp => {
                    const payloadToSend = {
                        actions: resp
                    };
                    this.apiGatewayListenerInstance.apiGatewayListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.platform.openSnackBar(this.plugin['name'] + ' successfully configured for the route ' + this.gatewayRoute['data'][i]['name'], 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                resolve('success');
            }, error => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'apigateway_services_applytoroute_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {serviceName: this.gatewayService['name'], routeName: gatewayRoute['data'][i]['name'], payload: this.plugin}, error, this.router.url)).then(resp => {
                    const payloadToSend = {
                        actions: resp
                    };
                    this.apiGatewayListenerInstance.apiGatewayListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                const unique_violation_string = 'Error while configuring route' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '',
                    unique_substring = 'UNIQUE';
                if (unique_violation_string.includes(unique_substring)) {
                    this.platform.openSnackBar(this.plugin['name'] + ' is already configured for the route ' + this.gatewayRoute['data'][i]['name'], 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                } else {
                    this.platform.openSnackBar('Error while configuring route' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
                resolve('failed');
            });
        });
        // location.reload();
    }

    async createPluginForService(plugin) {
        if (this.pluginsConfiguredForService) {
            // if ((this.pluginsConfiguredForService.filter(element => element.name === plugin.name)).length === 0) {
                await this.kong.getServicesFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + this.entity + '-' + this.version).subscribe(service => {
                    this.gatewayService = service;
                    this.kong.createPluginForServiceInApiGateway(this.gatewayService['name'], plugin).toPromise().then(response => {

                        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_services_addgatewaysettings_success', 'INFO', 200, 'OK', '', {serviceName: this.gatewayService['name'], payload: plugin}, response, this.router.url)).then(resp => {
                            const payloadToSend = {
                                actions: resp
                            };
                            this.apiGatewayListenerInstance.apiGatewayListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });

                        const data = {
                            plugin: plugin
                        };
                        const dialogRef1 = this.dialog.open(ConfigureInRouteComponent, {
                            width: '40%',
                            height: '40%',
                            data: data
                        });
                        dialogRef1.afterClosed().subscribe(response2 => {
                            if (response2 === 'add') {

                                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_services_applytoroute_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
                                    const payloadToSend = {
                                        actions: response
                                    };
                                    this.apiGatewayListenerInstance.apiGatewayListener.emit({
                                        type: 'audit',
                                        id: localStorage.getItem('IdOfSession'),
                                        payload: payloadToSend
                                    });
                                });

                                this.kong.getRoutesForAServiceFromApiGateway(this.partner + '-' + this.account + '-' + this.entity + '-' + this.version).toPromise().then(async route => {
                                    this.gatewayRoute = route;
                                    // $.when(this.createPluginsInAllRoutes(this.gatewayRoute)).then(this.reload());
                                    await this.createPluginsInAllRoutes(this.gatewayRoute);
                                    // location.reload();
                                }, error => {
                                    this.platform.handleErrorGracefully(error, 'Error while fetching routes for the service from API Gateway. Please try after sometime.');
                                });
                            } else {
                                // this.platform.openSnackBar(plugin.name + ' successfully configured for this service', 'Success', {
                                //     duration: 5000,
                                //     verticalPosition: 'top',
                                //     horizontalPosition: 'center'
                                // });
                                location.reload();
                            }
                        });
                    }, error => {
                        Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'apigateway_services_addgatewaysettings_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {serviceName: this.gatewayService['name'], payload: plugin}, error, this.router.url)).then(resp => {
                            const payloadToSend = {
                                actions: resp
                            };
                            this.apiGatewayListenerInstance.apiGatewayListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });
                        const unique_violation_string = 'Error while configuring service' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '',
                            unique_substring = 'UNIQUE';
                        if (unique_violation_string.includes(unique_substring)) {
                            this.platform.openSnackBar(plugin.name + ' is already configured for this service', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        } else {
                            this.platform.openSnackBar('Service already configured' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                        // location.reload();
                    });
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while fetching the service from API Gateway. Please try after sometime.');
                });
            // } else {
            //     this.platform.openSnackBar(plugin.name + ' already configured for this service' , 'Error', {
            //         duration: 5000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // }
        }
    }

    createPluginForRoute(indexOfRoute) {
        this.kong.getRoutesForAServiceFromApiGateway(this.partner + '-' + this.account + '-' + this.entity + '-' + this.version).subscribe(route => {
            this.gatewayRoute = route;
            this.kong.createPluginForRouteInApiGateway(this.gatewayRoute['data'][indexOfRoute]['name'], this.plugin).subscribe(response => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_routes_addgatewaysettings_success', 'INFO', 200, 'OK', '', {routeName: this.gatewayRoute['data'][indexOfRoute]['name'], payload: this.plugin}, response, this.router.url)).then(resp => {
                    const payloadToSend = {
                        actions: resp
                    };
                    this.apiGatewayListenerInstance.apiGatewayListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.platform.openSnackBar(this.plugin.name + ' successfully configured for the route' + this.gatewayRoute['data'][indexOfRoute]['name'], 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                setTimeout(() => {
                    location.reload();
                })
            }, error => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'apigateway_routes_addgatewaysettings_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {routeName: this.gatewayRoute['data'][indexOfRoute]['name'], payload: this.plugin}, error, this.router.url)).then(resp => {
                    const payloadToSend = {
                        actions: resp
                    };
                    this.apiGatewayListenerInstance.apiGatewayListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                const unique_violation_string = error['error']['message'],
                    unique_substring = 'UNIQUE';
                if (unique_violation_string.includes(unique_substring)) {
                    this.platform.openSnackBar(this.plugin.name + ' already configured in the route' + this.gatewayRoute['data'][indexOfRoute]['name'], 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                } else {
                    this.platform.openSnackBar('Error while configuring route' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            });
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while fetching the routes for the service from API Gateway. Please try after sometime.');
        });
    }

    sendGatewayServiceSettings() {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_services_update_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.apiGatewayListenerInstance.apiGatewayListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        const service = {
            name: this.gatewayService['name'],
            protocol: this.gatewayService['protocol'],
            host: this.gatewayService['host'],
            port: this.gatewayService['port'],
            path: this.gatewayService['path'],
            retries: this.gatewayService['retries'],
            connect_timeout: this.gatewayService['connect_timeout'],
            read_timeout: this.gatewayService['read_timeout'],
            write_timeout: this.gatewayService['write_timeout'],
            // tags: this.gatewayService['tags']
            // tls_verify: this.gatewayService['tls_verify'],
            // ca_certificates: this.gatewayService['ca_certificates'],
        };
        if (this.gatewayService['client_certificate'] !== null && this.gatewayService['client_certificate'] !== undefined && this.gatewayService['client_certificate'] !== '') {
            service['client_certificate'] = {id: this.gatewayService['client_certificate']};
        }

        // const service = {
        //     'name': $('#serviceName').val(),
        //     'protocol': $('#serviceProtocol').val(),
        //     'host': $('#serviceHost').val(),
        //     'port': $('#servicePort').val(),
        //     'path': $('#servicePath').val(),
        //     'retries': $('#serviceRetries').val(),
        //     'connect_timeout': $('#serviceConnectTimeout').val(),
        //     'read_timeout': $('#serviceReadTimeout').val(),
        //     'write_timeout': $('#serviceWriteTimeout').val(),
        //     'tags': $('#serviceTags').val()
        // };
        // this.kong.updateServiceInApiGateway($('#serviceName').val(), service).subscribe(res => {

        this.kong.updateServiceInApiGateway(this.gatewayService['name'], service).subscribe(data => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_services_update_success', 'INFO', 200, 'OK', '', {serviceName: this.gatewayService['name'], payload: service}, data, this.router.url)).then(resp => {
                const payloadToSend = {
                    actions: resp
                };
                this.apiGatewayListenerInstance.apiGatewayListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            this.platform.openSnackBar('Gateway service updated successfully.', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'apigateway_services_update_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {serviceName: this.gatewayService['name'], payload: service}, error, this.router.url)).then(resp => {
                const payloadToSend = {
                    actions: resp
                };
                this.apiGatewayListenerInstance.apiGatewayListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            this.platform.handleErrorGracefully(error, 'Error while updating the service in API Gateway. Please try after sometime.');
        });
    }


    sendGatewayRoutes() {
        const routes = {
            'name': $('#serviceName').val(),
            'protocol': $('#serviceProtocol').val(),
            'host': $('#serviceHost').val(),
            'port': $('#servicePort').val(),
            'path': $('#servicePath').val(),
            'retries': $('#serviceRetries').val(),
            'connect_timeout': $('#serviceConnectTimeout').val(),
            'read_timeout': $('#serviceReadTimeout').val(),
            'write_timeout': $('#serviceWriteTimeout').val(),
            'tags': $('#serviceTags').val()
        };
    }

    sendGatewayAcl() {
        const acl = {
            'consumer': $('#aclConsumer').val(),
            'whitelist': $('#aclWhitelist').val(),
            'blacklist': $('#aclBlacklist').val()
        };

    }

    sendGatewayBotDetection() {
        const botDetection = {
            'consumer': $('#botDetectionConsumer').val(),
            'whitelist': $('#botDetectionWhitelist').val(),
            'blacklist': $('#botDetectionBlacklist').val()
        };
    }

    sendGatewayCors() {
        const cors = {
            'consumer': $('#corsconsumer').val(),
            'origins': $('#corsorigins').val(),
            'headers': $('#corsheaders').val(),
            'exposed_headers': $('#corsexposedheaders').val(),
            'methods': $('#corsmethods').val(),
            'credentials': $('#corscredentials').val(),
            'continue_preflight': $('#corscontinuepreflight').val()
        };
    }

    sendGatewayIpRestriction() {
        const ipRestriction = {
            'consumer': $('#ipRestrictionConsumer').val(),
            'whitelist': $('#ipRestrictionWhitelist').val(),
            'blacklist': $('#ipRestrictionBlacklist').val()
        };
    }

    sendGatewayRequestTermination() {
        const requestTermination = {
            'consumer': $('#requestTerminationConsumer').val(),
            'status_code': $('#requestTerminationStatusCode').val(),
            'message': $('#requestTerminationMessage').val(),
            'content_type': $('#requestTerminationContentType').val(),
            'body': $('#requestTerminationBody').val()
        };
    }

    sendGatewayRequestSizeLimiting() {
        const requestSizeLimiting = {
            'consumer': $('#requestSizeLimitingConsumer').val(),
            'payload_size': $('#requestSizeLimitingPayloadSize').val()
        };
    }

    sendGatewayRateLimiting() {
        const rateLimitingConfig = {
            'consumer': $('#rateLimitingConsumer').val(),
            'second': parseInt($('#rateLimitingSecond').val(), 10),
            'minute': parseInt($('#rateLimitingMinute').val(), 10),
            'hour': parseInt($('#rateLimitingHour').val(), 10),
            'day': parseInt($('#rateLimitingDay').val(), 10),
            'month': parseInt($('#rateLimitingMonth').val(), 10),
            'year': parseInt($('#rateLimitingYear').val(), 10),
            'limit_by': $('#rateLimitingLimitBy').val(),
            'policy': $('#rateLimitingPolicy').val()
        };
        const rateLimiting = {
            'enabled': this.rateLimitingEnabled,
            'consumer': $('#rateLimitingConsumer').val(),
            'config': rateLimitingConfig
        };

        this.kong.patchPluginInApiGateway(this.rateLimitingId, rateLimiting).subscribe(patchRes => {
            this.kong.patchPluginForRouteInApiGateway(this.pathRouteId, this.pathRouteRateLimitingPluginId, rateLimiting).subscribe(pathRouteRateLimitingUpdate => {
                this.kong.patchPluginForRouteInApiGateway(this.hostRouteId, this.hostRouteRateLimitingPluginId, rateLimiting).subscribe(hostRouteRateLimitingUpdate => {
                    this.platform.openSnackBar('Updated rate limiting attributes successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            });
            // }, error => {
            //     this.platform.openSnackBar('Error while updating rate limiting attributes for this service', 'Error', {
            //         duration: 5000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
        });
    }

    sendGatewayJwt() {
        const jwtConfig = {
            'maximum_expiration': $('#jwtMaximumExpiration').val(),
            'uri_param_names': $('#jwtUriParamNames').val(),
            'cookie_names': $('#jwtCookieNames').val(),
            'key_claim_name': $('#jwtKeyClaimName').val(),
            'claims_to_verify': $('#jwtClaimsToVerify').val(),
            'secret_is_base64': $('#jwtSecretIsBase64').val(),
            'anonymous': $('#jwtAnonymous').val(),
            'run_on_preflight': $('#jwtRunOnPreflight').val()
        };

        const jwt = {
            'enabled': this.jwtEnabled,
            'consumer': $('#jwtConsumer').val(),
            'config': jwtConfig
        };

        this.kong.patchPluginInApiGateway(this.jwtId, jwt).subscribe(patchRes => {
            this.kong.patchPluginForRouteInApiGateway(this.pathRouteId, this.pathRouteKeyAuthPluginId, jwt).subscribe(pathRouteJwtUpdate => {
                this.kong.patchPluginForRouteInApiGateway(this.hostRouteId, this.hostRouteKeyAuthPluginId, jwt).subscribe(hostRouteJwtUpdate => {
                    this.platform.openSnackBar('Updated JWT attributes successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            });
        }, error => {
            this.platform.openSnackBar('Error while updating JWT Authentication attributes for this service', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });


    }

    sendGatewayBasicAuth() {
        const basicAuth = {
            'enabled': this.basicAuthEnabled,
            'consumer': $('#keyAuthConsumer').val(),
            'config': this.basicAuthInstance.data
        };

        this.kong.patchPluginInApiGateway(this.basicAuthId, basicAuth).subscribe(patchRes => {
            this.kong.patchPluginForRouteInApiGateway(this.pathRouteId, this.pathRouteBasicAuthPluginId, basicAuth).subscribe(pathRouteBasicAuthUpdate => {
                this.kong.patchPluginForRouteInApiGateway(this.hostRouteId, this.hostRouteBasicAuthPluginId, basicAuth).subscribe(hostRouteBasicAuthUpdate => {
                    this.platform.openSnackBar('Updated Basic Auth attributes successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            });
        }, error => {
            this.platform.openSnackBar('Error while updating Basic Authentication attributes for this service', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    sendGatewayKeyAuth() {
        const keyAuthConfig = {
            'keyNames': $('#keyAuthKeyNames').val(),
            'hide_credentials': $('#keyAuthHideCredentials').val(),
            'anonymous': $('#keyAuthAnonymous').val(),
            'key_in_body': $('#keyAuthKeyInBody').val(),
            'run_on_preflight': $('#RunOnPreflight').val(),
        };

        const keyAuth = {
            'enabled': this.keyAuthEnabled,
            'consumer': $('#keyAuthConsumer').val(),
            'config': keyAuthConfig
        };

        this.kong.patchPluginInApiGateway(this.keyAuthId, keyAuth).subscribe(patchRes => {
            this.kong.patchPluginForRouteInApiGateway(this.pathRouteId, this.pathRouteKeyAuthPluginId, keyAuth).subscribe(pathRouteKeyAuthUpdate => {
                this.kong.patchPluginForRouteInApiGateway(this.hostRouteId, this.hostRouteKeyAuthPluginId, keyAuth).subscribe(hostRouteKeyAuthUpdate => {
                    this.platform.openSnackBar('Updated Key Auth attributes successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            });
        }, error => {
            this.platform.openSnackBar('Error while updating Key Authentication attributes for this service', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });


    }

    getKey(val) {
        return Object.values(val);
    }

    getGatewayItems() {

        this.error = false;
        this.confPost.getEntity(this.partner, this.account, this.entity, this.version).subscribe(
            items => {
                this.items = items;
                this.attributes = this.items.attributes;
                this.operations = this.items.operations;
                // this.gatewaySettings = this.items.gateway;

                this.kong.getServicesFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + this.entity + '-' + this.version).subscribe(service => {
                    this.gatewayService = service;
                    this.serviceId = this.gatewayService.id;
                    this.kong.getRoutesForAServiceFromApiGateway(this.partner + '-' + this.account + '-' + this.entity + '-' + this.version).subscribe(routes => {
                        this.gatewayRoutes = routes;
                        this.routes = this.gatewayRoutes.data;
                        this.routes.forEach(route => {
                            if (route.name === this.partner + '-' + this.account + '-' + this.entity + '-' + this.version + '-path') {
                                this.pathRouteId = route.id;

                            } else if (route.name === this.partner + '-' + this.account + '-' + this.entity + '-' + this.version + '-host') {
                                this.hostRouteId = route.id;
                            }
                        });

                        this.kong.getPluginsForRouteInApiGateway(this.pathRouteId).subscribe(pathRoutePluginRes => {
                            this.pathRoutePlugins = pathRoutePluginRes;
                            this.pathRoutePlugins.data.forEach(pathRoutePlugin => {
                                if (pathRoutePlugin.name === 'rate-limiting') {
                                    this.pathRouteRateLimitingPluginId = pathRoutePlugin.id;
                                } else if (pathRoutePlugin.name === 'key-auth') {
                                    this.pathRouteKeyAuthPluginId = pathRoutePlugin.id;
                                } else if (pathRoutePlugin.name === 'basic-auth') {
                                    this.pathRouteBasicAuthPluginId = pathRoutePlugin.id;
                                }
                            });
                        });
                        this.kong.getPluginsForRouteInApiGateway(this.hostRouteId).subscribe(hostPluginRes => {
                            this.hostRoutePlugins = hostPluginRes;
                            this.hostRoutePlugins.data.forEach(hostRoutePlugin => {
                                if (hostRoutePlugin.name === 'rate-limiting') {
                                    this.hostRouteRateLimitingPluginId = hostRoutePlugin.id;
                                } else if (hostRoutePlugin.name === 'key-auth') {
                                    this.hostRouteKeyAuthPluginId = hostRoutePlugin.id;
                                } else if (hostRoutePlugin.name === 'basic-auth') {
                                    this.hostRouteBasicAuthPluginId = hostRoutePlugin.id;
                                }
                            });
                        });


                    });
                    this.kong.getPluginsForServiceInApiGateway(this.partner + '-' + this.account + '-' + this.entity + '-' + this.version).subscribe(plugins => {
                        this.gatewayPlugins = plugins;
                        this.gatewayPlugins.data.forEach(plugin => {
                            if (plugin.name === 'rate-limiting') {
                                this.rateLimiting = plugin.config;
                                this.rateLimitingId = plugin.id;
                                this.rateLimitingEnabled = plugin.enabled;

                            } else if (plugin.name === 'basic-auth') {
                                this.basicAuth = plugin.config;
                                this.basicAuthId = plugin.id;
                                this.basicAuthEnabled = plugin.enabled;

                            } else if (plugin.name === 'key-auth') {
                                this.keyAuth = plugin.config;
                                this.keyAuthId = plugin.id;
                                this.keyAuthEnabled = plugin.enabled;

                            } else if (plugin.name === 'jwt') {
                                this.jwt = plugin.config;
                                this.jwtId = plugin.id;
                                this.jwtEnabled = plugin.enabled;

                            } else if (plugin.name === 'request-size-limiting') {
                                this.requestSizeLimiting = plugin.config;
                                this.requestSizeLimitingId = plugin.id;
                                this.requestSizeLimitingEnabled = plugin.enabled;

                            } else if (plugin.name === 'request-termination') {
                                this.requestTermination = plugin.config;
                                this.requestTerminationId = plugin.id;
                                this.requestTerminationEnabled = plugin.enabled;

                            } else if (plugin.name === 'cors') {
                                this.cors = plugin.config;
                                this.corsId = plugin.id;
                                this.corsEnabled = plugin.enabled;

                            } else if (plugin.name === 'acl') {
                                this.acl = plugin.config;
                                this.aclId = plugin.id;
                                this.aclEnabled = plugin.enabled;

                            } else if (plugin.name === 'bot-detection') {
                                this.botDetection = plugin.config;
                                this.botDetectionId = plugin.id;
                                this.botDetectionEnabled = plugin.enabled;

                            } else if (plugin.name === 'ip-restriction') {
                                this.ipRestriction = plugin.config;
                                this.ipRestrictionId = plugin.id;
                                this.ipRestrictionEnabled = plugin.enabled;
                            } else {
                            }
                        });
                    });
                });
            },
            error => {
                this.error = true;
                this.errorMessage = (error.error.message ? error.error.message : error.error);
            }
        );
    }

}

@Component({
    selector: 'app-popup',
    templateUrl: 'popUp.component.html',
//     styleUrls: ['dialog-overview-example.css'],
})
export class PopUpComponent {

    pluginData: any;

    constructor(
        public dialogRef: MatDialogRef<PopUpComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PluginData) {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'apply-to-route',
    templateUrl: 'apply-to-route.component.html',
//     styleUrls: ['dialog-overview-example.css'],
})
export class ApplyToRouteComponent {

    constructor(
        public dialogRef: MatDialogRef<ApplyToRouteComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ApplyConfigurationsToRouteData) {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'configure-in-route',
    templateUrl: 'configure-in-route.component.html',
//     styleUrls: ['dialog-overview-example.css'],
})
export class ConfigureInRouteComponent {

    constructor(
        public dialogRef: MatDialogRef<ConfigureInRouteComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ApplyConfigurationsToRouteData) {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}

